import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import appIcon from "@/assets/app-icon.png";

export default function ConfirmPage() {
  const navigate = useNavigate();

  // Sign out any auto-created session so the user must log in manually
  useEffect(() => {
    supabase.auth.signOut();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-sm"
      >
        <img src={appIcon} alt="Jobily" className="w-14 h-14 rounded-2xl mx-auto mb-5" />

        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="w-7 h-7 text-primary" />
        </div>

        <h1 className="font-display font-bold text-xl mb-2">Thank You for Signing Up!</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Your email has been verified successfully. You can now sign in to start your onboarding.
        </p>

        <Button onClick={() => navigate("/")} className="w-full h-11">
          Return to Login
        </Button>
      </motion.div>
    </div>
  );
}
